import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerXmarkSharpLine = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998V3.911l-1.627 1.308-5.058 4.066H3.001v6.288h3.372l5.085 3.27 1.541.992V5.998Zm-5.706 5.067 3.705-2.98v8.085l-3.79-2.438-.248-.16h-1.96v-2.287H7.02l.274-.22ZM15 8.085l.707.708 1.793 1.793 1.793-1.793.707-.707L21.414 9.5l-.707.707L18.914 12l1.793 1.793.707.707L20 15.914l-.707-.707-1.793-1.793-1.793 1.793-.707.707-1.414-1.414.707-.707L16.086 12l-1.793-1.793-.707-.707L15 8.086Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerXmarkSharpLine);
export default Memo;
